import { SectionContainer } from "@/components/Sections";
import React from "react";
import { CompetenceBaseWithChildrenEx } from "@/server/backend-api";
import { TopicCardWithSubtopics } from "@/components/MotivationScan/TopicCardWithSubtopics";
import {
  MotivationScanAnswers,
  MotivationScanLike,
} from "@/utils/motivationScan";
import Button from "@/components/Button";
import { mcn } from "@/utils";
import { useLogging } from "@/utils/appInsights/client";
import { MOTIV_SCAN_COMPLETED } from "@/utils/appInsights/eventsNames";

interface Props {
  competences: CompetenceBaseWithChildrenEx[];
  answers: MotivationScanAnswers;
  onPreviousClicked?: () => void;
  onGetResultClicked?: () => void;
  onSubcompetenceClicked?: (
    c: CompetenceBaseWithChildrenEx,
    likeOrDislike: MotivationScanLike
  ) => void;
  onSubcompetenceSelectDeselectAllClicked?: (
    c: CompetenceBaseWithChildrenEx,
    selectOrDeselect: "select" | "deselect"
  ) => void;
}

export function MotivationScanSecondStep(props: Props) {
  const {
    competences,
    answers,
    onSubcompetenceClicked,
    onSubcompetenceSelectDeselectAllClicked,
  } = props;
  const likedCompetences = competences.filter(
    (c) => answers[c.id]?.likeOrDislike === MotivationScanLike.Like
  );
  const { trackEvent } = useLogging();
  return (
    <>
      <SectionContainer defaultPadding={false}>
        <div className="flex flex-col justify-center items-center mt-lg">
          <h1 className="text-style-headline5 tablet:text-style-headline3">
            Let&#39;s get more specific
          </h1>
          <span className="mt-sm max-w-[500px] text-center">
            &#39;Like&#39; any of the options within the topics you have already
            selected to help us customise your results and suggestions even
            more.
          </span>
        </div>

        <div className="grid grid-cols-1 w-full tablet:grid-cols-2 desktop:grid-cols-3 gap-x-md gap-y-lg pt-md tablet:pt-3xl">
          {likedCompetences.map((c, index) => {
            return (
              <div
                key={index}
                className={mcn(
                  "w-full col-span-1 order-2",
                  c.children.length > 7 &&
                    "tablet:col-span-2 tablet:order-1 col-span-1"
                )}
              >
                <TopicCardWithSubtopics
                  competence={c}
                  answers={answers}
                  onSubcompetenceLikeClicked={onSubcompetenceClicked}
                  onSelectDeselectAllClicked={(selectOrDeselect) =>
                    onSubcompetenceSelectDeselectAllClicked?.(
                      c,
                      selectOrDeselect
                    )
                  }
                />
              </div>
            );
          })}
        </div>
        <div className="flex justify-between mt-xl tablet:mt-2xl">
          <Button
            kind="secondary"
            label={"Back"}
            onClick={props.onPreviousClicked}
          />
          <Button
            label={"Get result"}
            onClick={() => {
              trackEvent(MOTIV_SCAN_COMPLETED);
              props.onGetResultClicked?.();
            }}
          />
        </div>
      </SectionContainer>
    </>
  );
}
